<template>
    <el-card shadow="never" class="aui-card--fill">
        <div class="mod-ums__memberbalance">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item v-if="visible">
                    <el-select v-model="dataForm.orgId" placeholder="请选择区域">
                        <el-option label="全选" value="" key=""></el-option>
                        <el-option
                                v-for="item in orgList"
                                :key="item.id"
                                :label="item.orgName"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.beginDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="开始时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <template>
                        <div class="block">
                            <el-date-picker
                                    v-model="dataForm.endDate"
                                    type="date"
                                    :clearable="true"
                                    format="yyyy年MM月dd日"
                                    value-format="yyyy-MM-dd"
                                    placeholder="结束时间">
                            </el-date-picker>
                        </div>
                    </template>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">{{ $t('query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
                </el-form-item>
                <!--                <el-form-item>-->
                <!--                    <el-button v-if="$hasPermission('ums:memberbalance:save')" type="primary"-->
                <!--                               @click="addOrUpdateHandle()">{{ $t('add') }}-->
                <!--                    </el-button>-->
                <!--                </el-form-item>-->
                <!--        <el-form-item>-->
                <!--          <el-button v-if="$hasPermission('ums:memberbalance:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
                <!--        </el-form-item>-->
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border
                      @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
                <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
                <el-table-column prop="orgName" label="所属区域" header-align="center" align="center"></el-table-column>
                <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="stockBalance" label="股票期权数" header-align="center" align="center"></el-table-column>
                <el-table-column prop="cashBalance" label="现金余额" header-align="center" align="center"></el-table-column>
                <el-table-column prop="diskRentBalance" label="租金余额" header-align="center" align="center"></el-table-column>
                <el-table-column prop="cashShare" label="分红现金余额" header-align="center" align="center"></el-table-column>
                <el-table-column prop="integrationBalance" label="优果余额" header-align="center"
                                 align="center"></el-table-column>
                <el-table-column prop="integrationShare" label="分红优果余额" header-align="center"
                                 align="center"></el-table-column>
                <!--        <el-table-column prop="cashLock" label="锁定现金" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="integrationLock" label="锁定优果" header-align="center" align="center"></el-table-column>
                <el-table-column prop="freezeCashAmount" label="冻结金额" header-align="center" align="center"></el-table-column>
                <el-table-column prop="lockAmount" label="锁定时长" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="bankName" label="银行名称" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="bankAccountName" label="银行开户名" header-align="center" align="center"></el-table-column>-->
                <!--        <el-table-column prop="bankCardNumber" label="银行卡号" header-align="center" align="center"></el-table-column>-->
                <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
                <!--        <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>-->
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="$hasPermission('ums:memberbalance:update')" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
                        <el-button v-if="$hasPermission('ums:memberbalance:update')" type="text" size="small"
                                                           @click="addBalanceHandle(scope.row.id)">人工调整账号余额
                                                </el-button>
                        <el-button v-if="$hasPermission('ums:memberbalance:transfer')" type="text" size="small"
                                   @click="addTransferHandle(scope.row.id)">转账
                        </el-button>
                        <el-button v-if="$hasPermission('ums:memberbalance:transfer')" type="text" size="small"
                                   @click="addStockBalanceHandle(scope.row.memberId)">兑换期权
                        </el-button>
                        <el-button v-if="$hasPermission('ums:memberbalance:transfer')" type="text" size="small"
                                   @click="addTranferStockMemberBalanceHandle(scope.row.memberId)">期权转账号余额
                        </el-button>
                        <el-button v-if="$hasPermission('cp:memberLock:cancelLock')" type="text" size="small"
                                   @click="cancelLockBalance(scope.row.memberId)">解除时长锁定
                        </el-button>
                        <el-button v-if="$hasPermission('cp:memberLock:dolockBalance')" type="text" size="small"
                                   @click="addLockBalance(scope.row.memberId)">锁定时长
                        </el-button>
                        <el-button v-if="$hasPermission('cp:memberLock:dolockBalance')" type="text" size="small"
                                   @click="addInnnerBalanceTransfer(scope.row.memberId)">帐内优果转移
                        </el-button>
                        <!--            <el-button v-if="$hasPermission('ums:memberbalance:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <AddBalance v-if="addBalanceVisible" ref="AddBalance"
                                     @refreshDataList="getDataList"></AddBalance>
            <TransferBalance v-if="addTransferVisible" ref="TransferBalance"
                        @refreshDataList="getDataList"></TransferBalance>
            <LockMemberBalance v-if="addLockMemberBalanceVisible" ref="LockMemberBalance"
                               @refreshDataList="getDataList"></LockMemberBalance>
            <StockBalance v-if="addStockMemberBalanceVisible" ref="StockBalance"
                               @refreshDataList="getDataList"></StockBalance>
            <StockTransferBalance v-if="tranferStockMemberBalanceVisible" ref="StockTransferBalance"
                                  @refreshDataList="getDataList"></StockTransferBalance>
            <InnnerBalanceTransfer v-if="innnerBalanceTransferVisible" ref="InnnerBalanceTransfer"
            @refreshDataList="getDataList"></InnnerBalanceTransfer>

        </div>
    </el-card>
</template>

<script>
    import mixinViewModule from '@/mixins/view-module'
    import AddOrUpdate from './memberbalance-add-or-update'
    import AddBalance from './memberbalance-add-balance'
    import TransferBalance from './memberbalance-transfer-balance'
    import LockMemberBalance from './memberbalance-lock-balance'
    import StockBalance from './memberbalance-stock-balance'
    import StockTransferBalance from './memberbalance-stock-transfer-balance'
    import InnnerBalanceTransfer from './memberbalance-inner-balance'
    export default {
        mixins: [mixinViewModule],
        data() {
            return {
                addBalanceVisible:false,
                addTransferVisible:false,
                addLockMemberBalanceVisible:false,
                addStockMemberBalanceVisible:false,
                tranferStockMemberBalanceVisible:false,
                innnerBalanceTransferVisible:false,
                visible: false,
                orgList: [],
                mixinViewModuleOptions: {
                    getDataListURL: '/ums/memberbalance/page',
                    getDataListIsPage: true,
                    exportURL: '/ums/memberbalance/export',
                    deleteURL: '/ums/memberbalance',
                    deleteIsBatch: true,
                    activatedIsNeed: false
                },
                dataForm: {
                    beginDate: "",
                    endDate:"",
                    mobileNumber: '',
                    memberName: '',
                    level: '',
                    orgId: '',
                    orgName:'',
                    isHead:false
                }
            }
        },
        created() {
            let d = new Date
            d.setMonth(d.getMonth()-1)
            this.dataForm.beginDate=d
        },
        mounted() {
            const that = this;
            that.getInfo();
        },
        methods:{
            getInfo() {
                this.$http.get(`/sys/user/info`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.orgId=res.data.orgId
                    this.dataForm.orgName=res.data.orgName
                    this.dataForm.isHead=res.data.isHead;
                    if (this.dataForm.isHead) {
                        this.visible=true;
                        this.getOrgList();
                    }
                    if(!this.mixinViewModuleOptions.activatedIsNeed){
                        this.getDataList()
                    }
                }).catch(() => {
                })
            },
            // 获取部门列表
            getOrgList() {
                return this.$http.get('/sys/org/select').then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.orgList = res.data
                }).catch(() => {
                })
            },
            addBalanceHandle (id) {
                console.log(id)
                this.addBalanceVisible=true
                this.$nextTick(() => {
                    this.$refs.AddBalance.init(id)
                })
            },
            addStockBalanceHandle (id) {
                console.log(id)
                this.addStockMemberBalanceVisible=true
                this.$nextTick(() => {
                    this.$refs.StockBalance.init(id)
                })
            },
            addInnnerBalanceTransfer(id) {
                console.log(id)
                this.innnerBalanceTransferVisible=true
                this.$nextTick(() => {
                    this.$refs.InnnerBalanceTransfer.init(id)
                })
            },
            addTranferStockMemberBalanceHandle (id) {
                console.log(id)
                this.tranferStockMemberBalanceVisible=true
                this.$nextTick(() => {
                    this.$refs.StockTransferBalance.init(id)
                })
            },
            addTransferHandle (id) {
                console.log(id)
                this.addTransferVisible=true
                this.$nextTick(() => {
                    this.$refs.TransferBalance.init(id)
                })
            },
            addLockBalance(id) {
                console.log(id);
                this.addLockMemberBalanceVisible=true
                this.$nextTick(() => {
                    this.$refs.LockMemberBalance.init(id)
                })
            },
            cancelLockBalance(id) {
              console.log(id)
                this.$confirm('是否确认解除时长锁定?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var data={memberId:id}
                    this.$http.post(`/cp/memberLock/cancelLock`,data).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            type: 'success',
                            message: '解除成功!'
                        });
                        this.getDataList();
                    }).catch(() => {
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '解除出错'
                    });
                });
            },
        },
        components: {
            AddOrUpdate,
            AddBalance,
            TransferBalance,
            LockMemberBalance,
            StockBalance,
            StockTransferBalance,
            InnnerBalanceTransfer
        }
    }
</script>
